
export function AppSectionSubTitle({ subtitle }: {
  subtitle: string;
})
{
  return (
<h2 className="section-subtitle mt-2">
  {subtitle}
</h2>
  )
}
